<template>
  <validation-form @on-submit="sendNotifications">
    <md-card>
      <md-card-content>
        <filter-options
          v-if="!hasValidRole(userRole, [Role.Teacher, Role.Counselor])"
          :data.sync="formData"
          :validations="sendAnnouncementValidations"
          :hasCheckBox="hasCheckBox"
          :serverValidations="serverValidations"
          ref="filterOptionsRef"
        ></filter-options>
        <filter-by-teacher
          v-if="hasValidRole(userRole, Role.Teacher)"
          :data.sync="formData"
          :validations="sendAnnouncementValidations"
          :hasCheckBox="hasCheckBox"
          :serverValidations="serverValidations"
          ref="filterOptionsRef"
        ></filter-by-teacher>
        <filter-by-counselor
          v-if="hasValidRole(userRole, Role.Counselor)"
          :data.sync="formData"
          :hasCheckBox="hasCheckBox"
          :serverValidations="serverValidations"
          ref="filterOptionsRef"
        ></filter-by-counselor>
        <div class="md-layout">
          <div class="md-layout-item md-size-25 md-small-size-100">
            <validation-field>
              <label>{{ $t("communication.template") }}</label>
              <md-select
                name="template"
                v-model="formData.template"
                @md-selected="selectTemplate"
                id="template"
              >
                <md-option
                  :value="template._id"
                  v-for="(template, templateIndex) in templateList"
                  :key="templateIndex"
                >
                  {{ template.name }}
                </md-option>
              </md-select>
            </validation-field>
          </div>

          <div class="md-layout-item md-size-25 md-small-size-100">
            <validation-field
              :validations="sendAnnouncementValidations.title"
              name="title"
            >
              <label>{{ $t("communication.title") }}</label>
              <md-input v-model="formData.title" required></md-input>
              <span
                style="top: 40px"
                class="md-error"
                v-if="serverValidations.title"
              >
                {{ serverValidations.title }}
              </span>
            </validation-field>
          </div>

          <div class="md-layout-item md-size-100 mt-5">
            <validation-field
              class="border border-gray-300 p-2"
              :validations="sendAnnouncementValidations.contents"
              name="content"
            >
              <md-textarea
                :placeholder="$t('communication.please_enter_content')"
                class="p-0"
                v-model="formData.contents"
              ></md-textarea>
              <span class="md-error" v-if="serverValidations.contents">
                {{ serverValidations.contents }}
              </span>
            </validation-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <footer class="flex justify-center">
      <md-button @click="goToPreviousPage">Cancel</md-button>
      <md-button class="md-success ml-4" type="submit">Send</md-button>
    </footer>
  </validation-form>
</template>
<script>
import FilterOptions from "./FilterOptions/index";
import FilterByTeacher from "./FilterOptions/FillterByTeacher";
import FilterByCounselor from "./FilterOptions/FilterByCounselor";
import { validations } from "@/validations/communication";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";

import {
  EDITOR_PLUGINS,
  EDITOR_TOOLBAR,
  EDITOR_API_KEY
} from "./Template/utils";
import { VARIABLE_SYSTEM } from "@/constants";
import { Message, genErrMsgOj } from "@/helpers/utils";
import omit from "lodash/omit";
import { service_paths } from "@/constants/Services";
import { hasHistory } from "@/helpers/utils";

export default {
  name: "SendAnnouncement",
  components: { FilterOptions, FilterByCounselor, FilterByTeacher },
  props: ["formData", "userRole"],
  data() {
    return {
      templateList: [],
      Role,
      EDITOR_API_KEY,
      hasCheckBox: false,
      EDITOR_TOOLBAR,
      VARIABLE_SYSTEM,
      EDITOR_PLUGINS,
      sendAnnouncementValidations: validations,
      serverValidations: {},
      hasValidRole
    };
  },
  watch: {
    "formData.recipients": function() {
      this.serverValidations.recipients &&
        delete this.serverValidations.recipients;
    },
    "formData.title": function() {
      this.serverValidations.title && delete this.serverValidations.title;
    },
    "formData.contents": function() {
      this.serverValidations.contents && delete this.serverValidations.contents;
    }
  },
  created() {
    this.getTemplates();
  },
  methods: {
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    sendNotifications() {
      let formData = Object.assign(
        { type: "announcement" },
        this.beforeSendNotification()
      );
      const errMsg = "Form invalid, please check again...";
      this.$axios
        .post(
          `${service_paths.communication_notification}/send`,
          formData,
          true,
          {},
          errMsg
        )
        .then(() => {
          Message.success("Successfully !");
          this.$emit("update-form-data", "announcement");
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
          }
        });
    },
    beforeSendNotification() {
      if (hasValidRole(this.userRole, Role.Counselor)) {
        this.formData.recipients = "Counselor";
        this.formData.filter_by = "Counselor";
      }
      this.formData = omit(this.formData, "attachments");
      switch (this.formData.filter_by) {
        case "Staff": {
          this.formData.staffs = this.formData.selectedList;
          break;
        }
        case "Grade": {
          this.formData.grades = this.formData.selectedList;
          break;
        }
        case "Class": {
          this.formData.classes = this.formData.selectedList;
          break;
        }
        case "Student": {
          this.formData.students = this.formData.selectedList;
          break;
        }
        case "Program": {
          this.formData.programs = this.formData.selectedList;
          break;
        }
        case "Term": {
          this.formData.terms = this.formData.selectedList;
          break;
        }
        case "Counselor": {
          this.formData.counselors = this.formData.selectedList;
          break;
        }
      }
      return this.formData;
    },
    getTemplates() {
      this.$axios
        .get(`${service_paths.communication_template}`, {
          type: "announcement"
        })
        .then(response => {
          this.templateList = response.data.data;
        });
    },
    selectTemplate(e) {
      let selectedTemplate = this.templateList.find(
        template => template._id === e
      );
      if (selectedTemplate) {
        this.formData.title = selectedTemplate.title;
        this.formData.contents = selectedTemplate.content;
        this.formData.variables = selectedTemplate.variables;
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
